import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { Athletes } from './';

const Header = ({ team }) => {
  const [athletesVisible, setAthletesVisible] = useState(false),
    { verified = {}, name, email, username } = team || {};

  if (!team) return null;

  function handleAthletesVisible() {
    setAthletesVisible(!athletesVisible);
  }

  return (
    <Col ht="90px">
      <Row ht="100%">
        <Col between wid="100%" ht="100%">
          <Row between>
            <Col noFlex>
              <Text marg="0 0 0px" med>
                {name}
              </Text>

              {team?.email?.includes('@') && (
                <Text b2 marg="0 0 0px">
                  {email}
                </Text>
              )}

              <Text c1 med col={theme.GREY_60}>
                @{username}
              </Text>
            </Col>
          </Row>

          <Row between>
            <Text b2>
              {team.sport && `${team.sport} club`}
            </Text>

            <Clickable onClick={handleAthletesVisible}>
              <Row center>
                <Text b2 med marg="0 8px 0 0">
                  {team.athletes?.length || 0} athletes
                </Text>

                <Icon type="rightChevron" dimensions={6} />
              </Row>
            </Clickable>
          </Row>
        </Col>
      </Row>

      <Athletes visible={athletesVisible} closeModal={handleAthletesVisible} user={team} />
    </Col>
  );
};

export default Header;
